import { capitalize as _capitalize } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { ContentManager } from '@vfgroup-oneplatform/foundation';

import { REQUEST_STATUS, REQUEST_TYPES } from './Enums';

const getBadgeLabel = status => {
  if (status === REQUEST_STATUS.COMPLETED) {
    return 'soho_requests_status_completed';
  } else {
    return _capitalize(status);
  }
};

const getRequestSubtitlePlaceHolder = (
  state,
  requestedCancellation,
  requestApprovedDate,
  requestedOrderDate,
) => {
  switch (state) {
    case REQUEST_STATUS.REJECTED:
    case REQUEST_STATUS.CANCELLED:
      return [requestedCancellation];

    case REQUEST_STATUS.COMPLETED:
      return [requestApprovedDate];

    default:
      return [requestedOrderDate];
  }
};

const formatAndInjectSubtitleToUserObject = (requests, subtitle) => {
  return requests?.map(_req => {
    const { user, cancellationDate, requestedDate, requestedApprovedDate, state } = _req ?? {};

    const requestedCancellation = moment(cancellationDate).format('DD.MM.yyyy');
    const requestApprovedDate = moment(requestedApprovedDate).format('DD.MM.yyyy');
    const requestedOrderDate = moment(requestedDate).format('DD.MM.yyyy');

    const subtitlePlaceHolders = getRequestSubtitlePlaceHolder(
      state,
      requestedCancellation,
      requestApprovedDate,
      requestedOrderDate,
    );

    if (state !== REQUEST_STATUS.PENDING) {
      subtitle = `${_capitalize(ContentManager.translate(getBadgeLabel(state)))} %1$s`;
    }

    return {
      name: user?.name,
      id: user?.id,
      subtitle,
      icon: user?.icon,
      requestStatus: state,
      subtitlePlaceHolders,
    };
  });
};

const getFilterBarTypeLabel = type => {
  switch (type) {
    case REQUEST_TYPES.ADDON:
      return 'soho_requests_filter_addons';
    case REQUEST_TYPES.DEVICE:
      return 'soho_requests_filter_devices';
    case REQUEST_TYPES.LICENCE:
      return 'soho_requests_filter_licences';
    default:
      return `${_capitalize(type)}s`;
  }
};

const requestPropTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.shape({
    taxRate: PropTypes.number,
    value: PropTypes.number,
    unit: PropTypes.string,
  }),
  icon: PropTypes.shape({
    uri: PropTypes.string,
  }),
  requests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      state: PropTypes.string,
      cancellationReason: PropTypes.string,
      cancellationDate: PropTypes.string,
      requestedDate: PropTypes.string,
      requestedApprovedDate: PropTypes.string,
      price: PropTypes.shape({
        taxRate: PropTypes.number,
        value: PropTypes.number,
        unit: PropTypes.string,
      }),
      user: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        icon: PropTypes.shape({
          uri: PropTypes.string,
        }),
        role: PropTypes.string,
        '@referredType': PropTypes.string,
      }),
    }),
  ),
};

export {
  getRequestSubtitlePlaceHolder,
  formatAndInjectSubtitleToUserObject,
  requestPropTypes,
  getBadgeLabel,
  getFilterBarTypeLabel,
};
